<script setup lang="ts">
import { QSelect } from 'quasar'
import { computed, ref, watch } from 'vue'

const props = defineProps<{
  dropdownOptions: any
  searchKeys: string[]
  selected: any
  rules?: any[]
  label?: string
  disable?: boolean
}>()
const emit = defineEmits<{
  (e: 'update:selected', data: any): void
  (e: 'removed', data: any): void
}>()
const value = computed({
  get() {
    return props.selected
  },
  set(data) {
    emit('update:selected', data)
  },
})
watch(value, (newValue) => {
  if (typeof inputRef.value !== 'undefined') {
    inputRef.value.updateInputValue('')
    value.value = newValue
  }
})

const options = ref([...props.dropdownOptions])
const inputRef = ref<undefined | QSelect>()
const updateSelected = (val: any) => {
  value.value = val
}
function filterFn(val: string, update: (fn: () => void) => void) {
  options.value = [...props.dropdownOptions]

  if (val === '' || typeof val === 'undefined' || val === null) {
    update(() => {
      options.value = [...props.dropdownOptions]
    })
    return
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const inputRef = ref()

  update(() => {
    const needle = val.toLowerCase()
    options.value = props.dropdownOptions.filter((v: any) => {
      return props.searchKeys.some((key) => {
        if (typeof v[key] === 'string') {
          return v[key].toLowerCase().indexOf(needle) > -1
        }
        if (typeof v[key] === 'number') {
          return String(v[key]).indexOf(needle) > -1
        }
      })
    })
  })
}
defineExpose({
  validate: () =>
    inputRef.value ? inputRef.value?.validate() : console.log('no input ref exists'),
})
</script>

<template>
  <q-select
    :model-value="value"
    ref="inputRef"
    @update:model-value="(val) => updateSelected(val)"
    :options="options"
    filled
    use-input
    :label="label"
    input-debounce="0"
    @filter="filterFn"
    color="accent"
    behavior="menu"
    :rules="rules"
    :disable="disable"
  >
    <template v-for="(slot, index) of Object.keys($slots)" :key="index" #[slot]="slotProps">
      <slot :name="slot" v-bind="slotProps"></slot>
    </template>
  </q-select>
</template>
